"use client";

import React from "react";
import { ArrowRight, MapPin, ShieldCheck } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Action() {
  const prefersReducedMotion = useReducedMotion();
  const animationProps = prefersReducedMotion ? {
    initial: {
      opacity: 1,
      y: 0
    },
    animate: {
      opacity: 1,
      y: 0
    }
  } : {
    initial: {
      opacity: 0,
      y: 16
    },
    whileInView: {
      opacity: 1,
      y: 0
    },
    viewport: {
      once: true,
      amount: 0.3
    },
    transition: {
      duration: 0.35,
      ease: [0.16, 1, 0.3, 1]
    }
  };
  return <section id="call-to-action" data-nav="light" className="border-t border-border bg-background py-14 md:py-20 lg:py-24">
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        <motion.div {...animationProps} className="relative overflow-hidden rounded-xl border border-border bg-card p-6 sm:p-8 md:p-12 lg:p-16 text-center shadow-sm">
          {/* Cold-Chain Dispatch Badge */}
          <div className="mb-6 inline-flex max-w-full items-center justify-center gap-2 rounded-full border border-border bg-muted px-3.5 py-1.5 text-center text-xs font-semibold tracking-wide text-foreground uppercase whitespace-normal">
            <span className="h-2 w-2 shrink-0 rounded-full bg-chart-2 animate-pulse" />
            <span className="text-center">Southern California &amp; Las Vegas-Area Service</span>
          </div>

          {/* Heading */}
          <h2 className="mx-auto max-w-2xl font-default text-3xl font-bold tracking-tight text-card-foreground sm:text-4xl md:text-5xl">Check Trailer Availability in Your Area</h2>

          {/* Supporting Subtext */}
          <p className="mx-auto mt-4 max-w-xl text-base text-muted-foreground sm:text-lg">Include your delivery address or ZIP code when requesting a quote so we can confirm service-area coverage, trailer availability, site-access requirements, and scheduling.</p>

          {/* Dual Action CTA Group */}
          <div className="mt-8 flex flex-col items-center justify-center gap-3.5 sm:flex-row sm:gap-4">
            <Button asChild size="lg" className="w-full sm:w-auto font-semibold shadow-xs">
              <Link to="/ContactRequestAQuotePage" className="inline-flex items-center gap-2">
                <span>Request a Quote</span>
                <ArrowRight className="h-4 w-4" />
              </Link>
            </Button>

            <a href="tel:2135218821" className="inline-flex items-center gap-2 px-3 py-2 text-sm font-medium text-muted-foreground">
              <span>213-521-8821</span>
            </a>
          </div>

          {/* Trust & Spec Micro Strip */}
          <div className="mt-10 pt-8 border-t border-border/80 flex flex-wrap items-center justify-center gap-6 text-xs text-muted-foreground">
            <div className="flex items-center gap-2">
              <ShieldCheck className="h-4 w-4 text-primary" />
              <span>Trailer options include 6×8, 7×12, and 7×16 refrigerated and freezer trailers, plus a 53-foot reefer trailer. Availability is confirmed individually.</span>
            </div>
            <div className="flex items-center gap-2">
              <MapPin className="h-4 w-4 text-primary" />
              <span>Delivery, positioning, setup, and pickup arrangements are confirmed with each quote. Site-access and delivery requirements for the 53-foot reefer are reviewed individually.</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}